import { TextBase, T1, T2 } from "./text";

export { TextBase, T1, T2 };
export default {
  T1,
  T2,
  TextBase,
};
